export const getErrorMessage = (err) => {
    const data = err?.response?.data
    if (data?.messages) {
        return  Object.values(data.messages).join("\n")
    }
    return "A aparut o eroare. Te rugam sa inceri din nou"
}